<template>
  <section class="mb-12 md:mb-20">
    <div class="container mx-auto max-w-[1200px] px-4">
      <h2 class="landing_h2 mb-4 md:mb-6 text-center">
        <Translate translate-key="more_info_about_selling.title" />
      </h2>
      <div
        class="w-full leading-relaxed prose prose-gray max-w-none prose-p:mb-3 prose-a:text-success"
      >
        <div class="w-full mb-10 sm:mb-20">
          <Translate
            class="flex mb-6 sm:mb-8"
            translate-key="more_info_about_selling.items.1.text"
          />
          <NuxtImg
            class="mb-8 sm:mb-10 md:mb-12 w-full mx-auto lg:max-w-[50%]"
            width="563"
            height="1069"
            sizes="sm:347px xl:563px"
            format="webp"
            loading="lazy"
            src="/pages/selling-tradelines/highest-commissions-paid-selling-tradelines-gfs-group-2025.png"
            :alt="t('more_info_about_selling.items.2.alt')"
          />
        </div>

        <div class="w-full mb-6 sm:mb-8">
          <Translate
            class="flex mb-10 sm:mb-20"
            translate-key="more_info_about_selling.items.2.text"
          />
          <NuxtImg
            class="mb-8 sm:mb-10 md:mb-12 w-full mx-auto lg:max-w-[50%]"
            width="563"
            height="317"
            sizes="sm:347px xl:563px"
            format="webp"
            src="/pages/selling-tradelines/total-commissions-paid-selling-tradelines-gfs-group-2025.png"
            :alt="t('more_info_about_selling.items.3.alt')"
            loading="lazy"
          />
        </div>

        <div class="w-full">
          <Translate
            class="text-center font-bold flex mb-2"
            translate-key="more_info_about_selling.items.3.text"
          />
          <div class="text-center mt-12 md:mt-16">
            <Button
              as="a"
              :href="linkHref('/cardholders-guideline')"
              variant="landing1"
              size="xl"
            >
              <Translate translate-key="more_info_about_selling.download" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { Button } from "~/shared/components/ui/button";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { linkHref } = useNativeRouteLink();
</script>
